<template>
  <b-row align-h="center" cols="1" class="p-4 m-0">
    <div class="d-flex align-items-center">
      <img src="/icons/alert.svg" alt="">
      <h5 class="mt-2" style="padding-left: 20px">Không có quyền truy cập!</h5>
    </div>
    <div class="content">
      <p>Tài khoản này không có quyền truy cập vào Salework Chat.</p>
      <p>Vui lòng liên hệ tài khoản admin để được cấp quyền</p>
    </div>
  </b-row>
</template>

<script>
export default {
  name: "PermissionModal",
}
</script>

<style scoped>
.content {
  padding-left: 40px;
  padding-top: 20px
}
</style>